import { render, staticRenderFns } from "./InputNumberPage.vue?vue&type=template&id=776fb478&scoped=true"
import script from "./InputNumberPage.vue?vue&type=script&lang=js"
export * from "./InputNumberPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776fb478",
  null
  
)

export default component.exports